import React, { useEffect, useState } from "react";
import "./styles/heroes.css";
import "./styles/home.css";
import "./styles/mediaqueries.css";
import logo from "../Assets/images/Logo_Square.png";
import { Link } from "react-router-dom";
import axios from "axios";
import Footer from "../components/Footer";
import heroFrame from "../Assets/images/Hero_List_Thumb_Normal_Frame.png";
import strength from "../Assets/images/Icon_Strength.png";
import intelligence from "../Assets/images/Icon_Intelligence.png";
import agility from "../Assets/images/Icon_Agility.png";
import spirit from "../Assets/images/Icon_Spirit.png";
import filterBg from "../Assets/images/Hero_Sort_Bg.png";

const Heroes = () => {
  const [heroData, setHeroData] = useState(null);
  const [heroes, setHeroes] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [selectedAbility, setSelectedAbility] = useState("");
  const getAbilityIcon = (attribute) => {
    let icon = "";
    switch (attribute) {
      case "Strength":
        icon = strength;
        break;
      case "Intelligence":
        icon = intelligence;
        break;
      case "Agility":
        icon = agility;
        break;
      case "Spirit":
        icon = spirit;
        break;
    }
    return <img className="ability_icon" src={icon} />;
  };
  const filterHeroes = (attributeType) => {
    setSelectedAbility(attributeType);
    if (selectedAbility === attributeType) {
      setHeroes(heroData);
      setSelectedAbility("");
      return;
    }
    setHeroes(
      heroData?.filter(
        (item) =>
          item.primaryAttribute.toLowerCase() == attributeType.toLowerCase()
      )
    );
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Roshpit Champions II | Heroes";
    axios
      .get("https://cotp-game.azurewebsites.net/api/HeroData/GetAllHeroes")
      .then((res) => {
        setHeroData(res?.data);
        setHeroes(res?.data);
      });
  }, []);
  useEffect(() => {
    setSelectedAbility("");
    if (searchValue.length > 0) {
      setHeroes(
        heroData?.filter((item) =>
          item.heroEnum.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    } else {
      setHeroes(heroData);
    }
  }, [searchValue]);
  return (
    <>
      <div className="heroes">
        <div className="heroes_heading_container container">
          <div className="heroes_heading">
            <p>Our Heroes</p>
            <span>
              Roshpit Champions boasts an astounding array of heroes that
              promises an unparalleled gaming experience. With an ever-expanding
              roster of unique and diverse characters, the game offers an
              astonishing variety of playstyles and strategies. Whether you
              prefer spellcasting mages, agile assassins, or stalwart defenders,
              Roshpit Champions provides an extensive lineup to cater to every
              gaming preference.
            </span>
          </div>
        </div>
        <div className="search container">
          <div className="filter_wrapper">
            <img src={filterBg} alt="" srcset="" />
            <div className="filter_content">
              <p>Filters</p>
              <div className="filter_ability_icons">
                <img
                  src={strength}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "strength"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterHeroes("strength")}
                />
                <img
                  src={agility}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "agility"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterHeroes("agility")}
                />
                <img
                  src={intelligence}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "intelligence"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterHeroes("intelligence")}
                />
                <img
                  src={spirit}
                  alt=""
                  srcset=""
                  className={`${
                    selectedAbility.toLowerCase() == "spirit"
                      ? "active_icon"
                      : ""
                  }`}
                  onClick={() => filterHeroes("spirit")}
                />
              </div>
            </div>
          </div>
          <div className="search_wrapper">
            <input
              type="text"
              placeholder="SEARCH"
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
            <i className="bi bi-search"></i>
          </div>
        </div>
        {heroes?.length === 0 ? (
          <div
            style={{
              width: "100%",
              color: "#fff",
              display: "flex",
              justifyContent: "center",
              marginTop: "5rem",
              fontSize: "2rem",
            }}
          >
            <p className="gradient_heading">No Hero Found</p>
          </div>
        ) : (
          <div className="heroes_container container">
            {heroes === null ? (
              <div className="video_overlay1">
                <div className="lds-ripple">
                  <div></div>
                  <div></div>
                </div>
                <p>Loading Heroes...</p>
              </div>
            ) : (
              heroes?.map((item, index) => {
                return (
                  <Link key={index} to={`/hero/${item.heroEnumValue}`}>
                    <div key={index} className="hero">
                      <img
                        src={heroFrame}
                        className="hero-frame"
                        alt=""
                        srcset=""
                      />
                      <div className="hero_img">
                        <img
                          src={item.heroRectangularPortrait}
                          alt={item.heroEnum}
                        />
                        <div className="hero_details">
                          <p className="">{item.heroEnum}</p>
                          {getAbilityIcon(item.primaryAttribute)}
                        </div>
                      </div>
                    </div>
                  </Link>
                );
              })
            )}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Heroes;
